import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import calls from './calls.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import invoices from './invoices.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import officeHours from './officeHours.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import setup from './setup.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import team from './team.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import sessionLimit from './sessionLimit.json';
import yearInReview from './yearInReview.json';
// One namespace per rail section, pre-created by Lane 0 so that no screen lane
// has to edit this shared file to introduce its own vocabulary (DECISIONS.md
// D5). Inbox and Settings are absent on purpose: `inbox.json` and
// `settings.json` already have a single owning lane.
import ai from './ai.json';
import workflows from './workflows.json';
import campaigns from './campaigns.json';
import reports from './reports.json';
import customers from './customers.json';
// Deals — the opportunity pipeline. Its own namespace beside `customers`,
// because a deal is its own noun with its own board vocabulary (pipeline,
// stage, won, lost).
import opportunities from './opportunities.json';
import channels from './channels.json';
import tickets from './tickets.json';
// The new support case engine, user-facing "Tickets". Its own namespace because
// `tickets.json` belongs to the conversation-lens tickets it will eventually
// replace; the two vocabularies coexist until that cutover.
import supportCases from './supportCases.json';
// Outbound MCP: the remote tool servers Tola AI may call. Its own namespace
// rather than a corner of `ai.json`, because it is a settings surface of its
// own with its own vocabulary (connector, transport, credential).
import mcpConnectors from './mcpConnectors.json';
import travel from './travel.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...calls,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...invoices,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...officeHours,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...setup,
  ...signup,
  ...sla,
  ...snooze,
  ...team,
  ...teamsSettings,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  ...onboarding,
  ...sessionLimit,
  ...yearInReview,
  ...ai,
  ...workflows,
  ...campaigns,
  ...reports,
  ...customers,
  ...opportunities,
  ...channels,
  ...tickets,
  ...supportCases,
  ...mcpConnectors,
  ...travel,
};
